module.exports = __webpack_public_path__ + "static/media/main idea.1c207572.mp3";